import { Swiper, Navigation } from 'swiper';

import 'swiper/swiper.scss';

Swiper.use([Navigation]);

(() => {
    const projectCarousels = document.querySelectorAll('[data-project-carousel]');

    Array.from(projectCarousels).map((projectCarousel) => {
        // eslint-disable-line no-new
        new Swiper(projectCarousel, {
            centeredSlidesBounds: true,
            observer: true,
            observeSlideChildren: true,
            slideToClickedSlide: true,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });
    });
})();

